import { useEffect, useState } from "react";
import { getJobExecutions, postStartProfilerJobs } from "../api/quontxApi";
import Pagination from "../components/Pagination";
import { useNavigate } from "react-router-dom";
import { truncateId } from "../utils";

const JobsPage = () => {
  const navigate = useNavigate();

  const [profilerJobsStarting, setProfilerJobsStarting] = useState(false);

  const [loadingData, setLoadingData] = useState(false);

  const [jobs, setJobs] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const ITEMS_PER_PAGE = 10;
  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);

  const handlePageChange = (page) => {
    loadJobs(page);
  };

  const handleDetailNavigation = (id) => {
    navigate(`/jobs/${id}`);
  };

  const startProfilerJobs = async () => {
    setProfilerJobsStarting(true);
    await postStartProfilerJobs();
    await loadJobs(currentPage);
    setProfilerJobsStarting(false);
  };

  const loadJobs = async (page) => {
    const jobs = await getJobExecutions(page, ITEMS_PER_PAGE);
    setJobs(jobs.data.data);
    setTotalItems(jobs.data.total_count);
    setCurrentPage(page);
  };

  useEffect(() => {
    (async () => {
      setLoadingData(true);
      await loadJobs(currentPage);
      setLoadingData(false);
    })();
  }, [currentPage]);

  return (
    <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold text-white mb-6">Job executions</h1>
      <div className="flex items-center gap-4">
        <button
          className="px-4 py-2 bg-blue-600 text-white text-sm rounded hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={() => startProfilerJobs()}
        >
          {profilerJobsStarting
            ? "Starting Profiler Job..."
            : "Start Profiler Job"}
        </button>
      </div>
      {loadingData && (
        <div className="text-center p-2 text-qtx-gray">Loading list...</div>
      )}
      <div className="bg-qtx-darker shadow-lg rounded-lg overflow-hidden mt-8">
        <table className="min-w-full">
          <thead className="bg-qtx-dark">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">
                UUID
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">
                Started at
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">
                Finished at
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">
                Started by
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">
                State
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-qtx-gray">
            {jobs.map((job) => (
              <tr key={job.uuid}>
                <td
                  className="px-6 py-4 whitespace-nowrap text-sm font-mono text-white cursor-pointer"
                  title={job.uuid}
                  onClick={() => navigator.clipboard.writeText(job.uuid)}
                >
                  {truncateId(job.uuid)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-mono text-white">
                  {job.started_at}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-mono text-white">
                  {job.finished_at}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-mono text-white">
                  {job.user.name}
                </td>
                <td
                  className="px-6 py-4 whitespace-nowrap text-sm font-mono text-white cursor-help"
                  title={job.error}
                >
                  {job.state}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-mono text-white">
                  <button
                    className="text-qtx-blue hover:text-blue-400"
                    onClick={() => handleDetailNavigation(job.uuid)}
                  >
                    View details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};

export default JobsPage;
